var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"md-grey-page center-horizontal"},[_c('section',{staticClass:"container-white"},[_vm._v("\n\t\t\tThank you for confirming your details. Your search has now been activated and we will contact you with any relevant information. "),_c('br'),_vm._v(" "),_c('a',{attrs:{"href":_vm.siteUrl}},[_vm._v(_vm._s(_vm.siteUrl))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-65982b0b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Owner-Confirm.vue
// module id = SKoC
// module chunks = 1